import React from 'react';
import { ReceiptIcon } from 'lucide-react';
const lines = [['Sorghum flour · 2kg', '3,600'], ['Cooking oil · 1L', '2,900'], ['Sugar · 500g', '1,150']];
export function SalesMock() {
  return <div className="w-full max-w-[330px] rounded-[12px] bg-white p-5 shadow-[0_18px_40px_-24px_rgba(11,11,11,0.28)]" data-id="element-822" data-mp="8vhij2ymce48">
      <div className="flex items-center justify-between border-b border-canvas-line pb-3" data-id="element-823" data-mp="3xg1sooo0qvx">
        <p className="text-[14px] font-semibold text-ink" data-id="element-824" data-mp="3cczof4utzb20">Sale #1284</p>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-brand px-2.5 py-1 text-[11px] font-semibold text-white" data-id="element-825" data-mp="37d3ih02kp9jt">
          <ReceiptIcon className="h-3 w-3" aria-hidden="true" data-id="element-826" data-mp="3m2jaejdubl13" />
          Receipt sent
        </span>
      </div>

      <ul className="mt-3 space-y-2.5" data-id="element-827" data-mp="3h9gfo7xbu5jb">
        {lines.map(([item, amount]) => <li key={item} className="flex items-center justify-between text-[13px]" data-id="element-828" data-mp="2tk5l586kl7dm">
            <span className="text-ink-muted" data-id="element-829" data-mp="2on5dwtxzhykx">{item}</span>
            <span className="font-medium text-ink" data-id="element-830" data-mp="2okj5yt76lh26">{amount}</span>
          </li>)}
      </ul>

      <div className="mt-4 flex items-center justify-between border-t border-canvas-line pt-3" data-id="element-831" data-mp="76cl54s0w220">
        <span className="text-[13px] font-semibold text-ink" data-id="element-832" data-mp="b7eex6367lwl">Total</span>
        <span className="text-[15px] font-semibold text-ink" data-id="element-833" data-mp="g10pmsprxfpr">7,650</span>
      </div>
    </div>;
}